export const PRINTING_BROWSER_KEY = "orizom.printing.browser.v1";
export const PRINTING_BROWSER_COOKIE = "orizom_print_browser";
export const PRINTING_BROWSER_MAX_AGE = 60 * 24 * 60 * 60;
export const PRINT_CONFIG_REQUIRED_EVENT = "orizom:print-config-required";
export const PRINT_STATION_CHANGED_EVENT = "orizom:print-station-changed";
export const PRINT_CONFIG_MESSAGE = "Nenhuma impressora selecionada para esta ação.";
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function readPrintingCookie(): string {
  const prefix = `${PRINTING_BROWSER_COOKIE}=`;
  for (const part of document.cookie.split(";")) {
    const cookie = part.trim();
    if (!cookie.startsWith(prefix)) continue;
    const value = cookie.slice(prefix.length);
    if (uuidPattern.test(value)) return value;
  }
  return "";
}

export function getPrintingBrowserId(): string {
  if (typeof window === "undefined" || typeof document === "undefined") return "";
  try {
    let id = readPrintingCookie();
    if (!id) {
      // Read the old storage only for migration; never generate or persist there again.
      try {
        const legacy = window.localStorage.getItem(PRINTING_BROWSER_KEY);
        if (legacy && uuidPattern.test(legacy)) id = legacy;
      } catch { /* Broken localStorage must not prevent cookie persistence. */ }
    }
    if (!id) {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
      id = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${PRINTING_BROWSER_COOKIE}=${id}; Max-Age=${PRINTING_BROWSER_MAX_AGE}; Path=/; SameSite=Lax${secure}`;
    if (readPrintingCookie() !== id) return "";
    // Remove the migration source only after confirming the cookie was accepted.
    try { window.localStorage.removeItem(PRINTING_BROWSER_KEY); } catch { /* Best effort. */ }
    return id;
  } catch { return ""; }
}

export async function printingStationFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
  const id = getPrintingBrowserId();
  if (id) headers.set("X-Orizom-Print-Browser", id);
  const response = await fetch(input, { ...init, headers });
  if (response.status === 409) {
    const data = await response.clone().json().catch(() => null);
    const path = input instanceof Request ? input.url : String(input);
    if (!/stations|printing-config/.test(path) && (data?.code === "PRINT_CONFIG_REQUIRED" || data?.message === PRINT_CONFIG_MESSAGE)) {
      window.dispatchEvent(new CustomEvent(PRINT_CONFIG_REQUIRED_EVENT, { detail: PRINT_CONFIG_MESSAGE }));
    }
  }
  return response;
}
